/** Затримки між повторними спробами оновити токен (мережа впала, сервер недоступний). */
export const REFRESH_RETRY_DELAYS_MS: ReadonlyArray<number> = [1000, 2000, 5000, 10000, 30000];

/** Мінімальний запас життя access-токена (сек), нижче якого оновлюємо його перед запитом / при поверненні у вкладку. */
export const MIN_TOKEN_VALIDITY_SECONDS = 30;

/** Затримки повторних спроб завантажити профіль користувача при мережевих / 5xx помилках. */
export const LOAD_USER_RETRY_DELAYS_MS: ReadonlyArray<number> = [1000, 3000, 5000];

/** Ключ у sessionStorage з часом останнього примусового редіректу на логін. */
export const LOGIN_REDIRECT_KEY = 'agri-auth:last-login-redirect';

/** Якщо редірект на логін повторюється частіше за це вікно — показуємо форму входу, щоб не зациклитись. */
export const LOGIN_REDIRECT_LOOP_WINDOW_MS = 2 * 60 * 1000;
